<div class="compare-layout" [class.drawing-mode]="mode !== null">
  <div class="compare-videos">
    <div class="compare-pane">
      <button type="button" class="swing-picker-btn" (click)="openPicker('left')">
        {{ paneTitle(left) }}
      </button>
      <div class="video-wrapper">
        <div class="video-content">
          <div class="missing-video" *ngIf="!left.swing">Choose a swing for the left video</div>
          <div class="missing-video" *ngIf="left.swing && !left.hasClip">
            No {{ activeCamera === 'faceon' ? 'Face-On' : 'Down the Line' }} video for this swing
          </div>
          <div class="video-loading" *ngIf="left.hasClip && left.isLoading">
            <img src="assets/noun-loader-3784345-FFFFFF.png" class="video-spinner" alt="" />
            <span>Downloading video...</span>
          </div>
          <video #leftVideo
                 *ngIf="left.hasClip"
                 preload="auto"
                 playsinline
                 muted
                 webkit-playsinline
                 [src]="left.videoUrl"
                 (loadedmetadata)="onVideoMetadata('left')"
                 (durationchange)="onVideoMetadata('left')"
                 (canplay)="onVideoCanPlay('left')"
                 (loadeddata)="onVideoCanPlay('left')"
                 (error)="onVideoLoadError('left')"
                 (timeupdate)="onTimeUpdate('left', $event)"
                 (ended)="onPlaybackEnded()">
          </video>
          <div
            class="draw-hitbox"
            *ngIf="mode !== null && left.hasClip"
            (pointerdown)="onMouseDown($event, 'left')"
            (pointermove)="onMouseMove($event, 'left')"
            (pointerup)="onMouseUp($event, 'left')"
            (pointerleave)="onMouseUp($event, 'left')"
            (pointercancel)="onMouseUp($event, 'left')">
          </div>
          <svg class="overlay"
               [class.drawing-enabled]="mode !== null"
               (pointerdown)="onMouseDown($event, 'left')"
               (pointermove)="onMouseMove($event, 'left')"
               (pointerup)="onMouseUp($event, 'left')"
               (pointerleave)="onMouseUp($event, 'left')"
               (pointercancel)="onMouseUp($event, 'left')">
            <ng-container *ngFor="let shape of leftShapes">
              <circle *ngIf="shape.type === 'circle'"
                      [attr.cx]="shape.cx" [attr.cy]="shape.cy"
                      [attr.r]="shape.r"
                      [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                      stroke-width="4" fill="transparent"
                      (pointerdown)="onShapeMouseDown($event, shape, 'left')"
                      (click)="selectShape($event, shape, 'left')"
                      class="hoverable"/>
              <line *ngIf="shape.type === 'line'"
                    [attr.x1]="shape.x1" [attr.y1]="shape.y1"
                    [attr.x2]="shape.x2" [attr.y2]="shape.y2"
                    [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                    stroke-width="4"
                    (pointerdown)="onShapeMouseDown($event, shape, 'left')"
                    (click)="selectShape($event, shape, 'left')"
                    class="hoverable"/>
            </ng-container>
          </svg>
          <div class="clear-shapes-hotspot" *ngIf="leftShapes.length > 0">
            <button
              type="button"
              class="clear-shapes-btn"
              (pointerdown)="$event.stopPropagation()"
              (click)="clearAllShapes($event, 'left')">
              Remove all shapes
            </button>
          </div>
        </div>
      </div>
      <div class="start-mark-row">
        <button
          type="button"
          class="start-mark-btn"
          [disabled]="!left.hasClip || left.isLoading || savingStartSide !== null"
          (click)="markStart('left')">
          {{ savingStartSide === 'left' ? 'Saving start...' : 'Mark start' }}
        </button>
        <span class="start-mark-meta" *ngIf="savedStartTime(left) !== null">
          Saved {{ formatTime(savedStartTime(left) ?? 0) }}
        </span>
        <span class="start-mark-meta" *ngIf="savedStartTime(left) === null">No start saved</span>
      </div>
      <div class="scrubber">
        <input
          type="range"
          class="scrubber-slider"
          min="0"
          [max]="left.duration || 0"
          [step]="sliderStep"
          [ngModel]="left.currentTime"
          (ngModelChange)="onPaneScrub('left', $event)"
          (pointerdown)="onPaneScrubStart('left')"
          (pointerup)="onPaneScrubEnd('left')"
          [disabled]="paneDisabled(left)"
          [style.--scrub-percent]="scrubPercent(left)"
          aria-label="Left swing position"
        />
        <div class="scrubber-times">
          <span>{{ formatTime(left.currentTime) }}</span>
          <span>{{ formatTime(left.duration) }}</span>
        </div>
      </div>
    </div>

    <div class="compare-pane">
      <button type="button" class="swing-picker-btn" (click)="openPicker('right')">
        {{ paneTitle(right) }}
      </button>
      <div class="video-wrapper">
        <div class="video-content">
          <div class="missing-video" *ngIf="!right.swing">Choose a swing to compare</div>
          <div class="missing-video" *ngIf="right.swing && !right.hasClip">
            No {{ activeCamera === 'faceon' ? 'Face-On' : 'Down the Line' }} video for this swing
          </div>
          <div class="video-loading" *ngIf="right.hasClip && right.isLoading">
            <img src="assets/noun-loader-3784345-FFFFFF.png" class="video-spinner" alt="" />
            <span>Downloading video...</span>
          </div>
          <video #rightVideo
                 *ngIf="right.hasClip"
                 preload="auto"
                 playsinline
                 muted
                 webkit-playsinline
                 [src]="right.videoUrl"
                 (loadedmetadata)="onVideoMetadata('right')"
                 (durationchange)="onVideoMetadata('right')"
                 (canplay)="onVideoCanPlay('right')"
                 (loadeddata)="onVideoCanPlay('right')"
                 (error)="onVideoLoadError('right')"
                 (timeupdate)="onTimeUpdate('right', $event)"
                 (ended)="onPlaybackEnded()">
          </video>
          <div
            class="draw-hitbox"
            *ngIf="mode !== null && right.hasClip"
            (pointerdown)="onMouseDown($event, 'right')"
            (pointermove)="onMouseMove($event, 'right')"
            (pointerup)="onMouseUp($event, 'right')"
            (pointerleave)="onMouseUp($event, 'right')"
            (pointercancel)="onMouseUp($event, 'right')">
          </div>
          <svg class="overlay"
               [class.drawing-enabled]="mode !== null"
               (pointerdown)="onMouseDown($event, 'right')"
               (pointermove)="onMouseMove($event, 'right')"
               (pointerup)="onMouseUp($event, 'right')"
               (pointerleave)="onMouseUp($event, 'right')"
               (pointercancel)="onMouseUp($event, 'right')">
            <ng-container *ngFor="let shape of rightShapes">
              <circle *ngIf="shape.type === 'circle'"
                      [attr.cx]="shape.cx" [attr.cy]="shape.cy"
                      [attr.r]="shape.r"
                      [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                      stroke-width="4" fill="transparent"
                      (pointerdown)="onShapeMouseDown($event, shape, 'right')"
                      (click)="selectShape($event, shape, 'right')"
                      class="hoverable"/>
              <line *ngIf="shape.type === 'line'"
                    [attr.x1]="shape.x1" [attr.y1]="shape.y1"
                    [attr.x2]="shape.x2" [attr.y2]="shape.y2"
                    [attr.stroke]="shape.selected ? '#fbbf24' : 'white'"
                    stroke-width="4"
                    (pointerdown)="onShapeMouseDown($event, shape, 'right')"
                    (click)="selectShape($event, shape, 'right')"
                    class="hoverable"/>
            </ng-container>
          </svg>
          <div class="clear-shapes-hotspot" *ngIf="rightShapes.length > 0">
            <button
              type="button"
              class="clear-shapes-btn"
              (pointerdown)="$event.stopPropagation()"
              (click)="clearAllShapes($event, 'right')">
              Remove all shapes
            </button>
          </div>
        </div>
      </div>
      <div class="start-mark-row">
        <button
          type="button"
          class="start-mark-btn"
          [disabled]="!right.hasClip || right.isLoading || savingStartSide !== null"
          (click)="markStart('right')">
          {{ savingStartSide === 'right' ? 'Saving start...' : 'Mark start' }}
        </button>
        <span class="start-mark-meta" *ngIf="savedStartTime(right) !== null">
          Saved {{ formatTime(savedStartTime(right) ?? 0) }}
        </span>
        <span class="start-mark-meta" *ngIf="savedStartTime(right) === null">No start saved</span>
      </div>
      <div class="scrubber">
        <input
          type="range"
          class="scrubber-slider"
          min="0"
          [max]="right.duration || 0"
          [step]="sliderStep"
          [ngModel]="right.currentTime"
          (ngModelChange)="onPaneScrub('right', $event)"
          (pointerdown)="onPaneScrubStart('right')"
          (pointerup)="onPaneScrubEnd('right')"
          [disabled]="paneDisabled(right)"
          [style.--scrub-percent]="scrubPercent(right)"
          aria-label="Right swing position"
        />
        <div class="scrubber-times">
          <span>{{ formatTime(right.currentTime) }}</span>
          <span>{{ formatTime(right.duration) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="playback-bar">
    <div class="scrubber linked-scrubber">
      <label class="control-label">Linked playback</label>
      <input
        type="range"
        class="scrubber-slider"
        min="0"
        [max]="linkedDuration || 0"
        [step]="sliderStep"
        [ngModel]="linkedTime"
        (ngModelChange)="onLinkedScrub($event)"
        (pointerdown)="onLinkedScrubStart()"
        (pointerup)="finishScrub(false)"
        [disabled]="linkedDisabled()"
        [style.--scrub-percent]="linkedPercent()"
        aria-label="Linked swing playback"
      />
      <div class="scrubber-times">
        <span>{{ formatTime(linkedTime) }}</span>
        <span>Line up each swing, then use this slider to move both together</span>
        <span>{{ formatTime(linkedDuration) }}</span>
      </div>
    </div>

    <div class="control-bar">
      <button class="video-btn" (click)="resetBoth()">
        <img src="../../../assets/noun-previous-1000026-FFFFFF.png" style="height: 35px;" alt="Reset">
      </button>
      <button class="video-btn" *ngIf="!isPlaying" (click)="playBoth()">
        <img src="../../../assets/noun-play-1000022-FFFFFF.png" style="height: 35px;" alt="Play">
      </button>
      <button class="video-btn" *ngIf="isPlaying" (click)="pauseBoth()">
        <img src="../../../assets/noun-pause-1000021-FFFFFF.png" style="height: 35px;" alt="Pause">
      </button>
      <div class="control-group">
        <label class="control-label">Playback Speed</label>
        <select class="control-select" [(ngModel)]="playbackSpeed">
          <option value="1">Full Speed</option>
          <option value="0.5">50%</option>
          <option value="0.25">25%</option>
          <option value="0.1">10%</option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="picker-backdrop" *ngIf="pickerSide" (click)="closePicker()">
  <div class="picker-modal" (click)="$event.stopPropagation()">
    <div class="picker-header">
      <h3>Select {{ pickerSide === 'left' ? 'left' : 'right' }} swing</h3>
      <button type="button" class="picker-close" (click)="closePicker()">×</button>
    </div>
    <select
      *ngIf="canCompareToOtherSwings"
      class="picker-filter picker-player"
      [(ngModel)]="pickerUsername"
      (ngModelChange)="onPickerPlayerChange()">
      <option *ngFor="let player of players" [value]="player.username">
        {{ player.firstName }} {{ player.lastName }}
      </option>
    </select>
    <input
      type="text"
      class="picker-filter"
      placeholder="Search by session, swing #, tags, notes, or thumbs..."
      [(ngModel)]="pickerFilter"
    >
    <div class="picker-body" *ngIf="!catalogLoading">
      <div class="picker-group" *ngFor="let group of filteredCatalog()">
        <button type="button" class="picker-session" (click)="toggleSession(group)">
          <span>
            {{ group.session.label }}
            <span class="picker-session-date">{{ group.session.sessionDate | date:'MMM d, y' }}</span>
          </span>
          <span>{{ group.expanded ? '▾' : '▸' }}</span>
        </button>
        <div *ngIf="group.expanded">
          <div class="picker-empty" *ngIf="group.swingsLoading">Loading swings...</div>
          <button
            type="button"
            class="picker-swing"
            *ngFor="let swing of swingsForGroup(group)"
            (click)="pickSwing(group, swing)">
            <span>Swing #{{ swing.sequence }}</span>
            <span class="picker-thumbs" *ngIf="resultLabel(swing)">{{ resultLabel(swing) }}</span>
            <span class="picker-meta" *ngIf="swing.tags.length">{{ swing.tags.join(', ') }}</span>
          </button>
          <div class="picker-empty" *ngIf="group.swingsLoaded && swingsForGroup(group).length === 0">No swings in this session</div>
        </div>
      </div>
      <div class="picker-empty" *ngIf="filteredCatalog().length === 0">No sessions found</div>
    </div>
    <div class="picker-body" *ngIf="catalogLoading">Loading sessions...</div>
  </div>
</div>
